<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { Label } from "reka-ui"
import { cn } from "@/shared/lib/utils"

const props = defineProps<{
  /** Звʼязок із полем за id (нативний for). */
  for?: string
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <Label
    data-slot="label"
    :for="props.for"
    :class="
      cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>
